import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnChanges,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import buildQuery from "odata-query";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  debounceTime,
  distinctUntilChanged,
  pluck,
  switchMap,
} from "rxjs/operators";
import { EMPTY, lastValueFrom, Subject } from "rxjs";
import { CommonModule, DatePipe } from "@angular/common";
import { ConfirmationService, MenuItem } from "primeng/api";
import { v4 as uuidv4 } from "uuid";
import { QuoteNotesGridComponent } from "../quote-notes-grid/quote-notes-grid.component";
import { QuoteNotesSidebarComponent } from "../quote-notes-sidebar/quote-notes-sidebar.component";
import { QuoteNotesSidebarService } from "../../../../core/services/quote-notes-sidebar.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { ApplyCreditCard } from "../../../../core/models/orders/applyCreditCard";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { GetAllBuyersRequestDto } from "../../../../core/models/orders/getAllBuyersRequestDto";
import { GetAllBuyersResponseDto } from "../../../../core/models/orders/getAllBuyersResponseDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { InvoiceEmail } from "../../../../core/models/orders/invoicedEmail";
import { InvoicedEmailSummaryDto } from "../../../../core/models/orders/InvoicedEmailSummaryDto";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { ConvertToSaleOrderDto } from "../../../../core/models/qoutes/convertToSaleOrderDto";
import { CopyQuotesRequestDto } from "../../../../core/models/qoutes/copyQuotesRequestDto";
import { QuotesHeaderAddressDto } from "../../../../core/models/qoutes/quotesHeaderAddressDto";
import { QuotesLineAddressDto } from "../../../../core/models/qoutes/quotesLineAddressDto";
import { QuotesLinePortalKeyDto } from "../../../../core/models/qoutes/quotesLinePortalKeyDto";
import { QuotesNotes } from "../../../../core/models/qoutes/quotesNotes";
import { UpdateDateRequestDto } from "../../../../core/models/qoutes/updateDateRequestDto";
import { UpdateQuotesHeaderDto } from "../../../../core/models/qoutes/updateQuotesHeaderDto";
import { Address } from "../../../../core/models/shared/address";
import { Contact } from "../../../../core/models/shared/contact";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ShipToAddressComponent } from "../../../../shared/components/ship-to-address/ship-to-address.component";
import { EnumCopiedFrom } from "../../../../shared/enums/copied-From.enum";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { AddClientContact } from "../../../../core/models/client/addClientContact";
import { TableModule } from "primeng/table";
import { DatePickerModule } from "primeng/datepicker";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { QuotesHeader } from "../../../../core/models/qoutes/quotesHeader";
import { QuotesInvoiceEmail } from "../../../../core/models/qoutes/quotesInvoiceEmail";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { Popover, PopoverModule } from "primeng/popover";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { CopyLinesQuotesDto } from "../../../../core/models/qoutes/copyLinesQuotesDto";
import { QuotesLine } from "../../../../core/models/qoutes/quoteLine";
import { QuoteSummaryLineItemsComponent } from "../quote-summary-line-items/quote-summary-line-items.component";
import { SummaryInvoiceEmailsComponent } from "../../../orders/components/summary-invoice-emails/summary-invoice-emails.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { PoEmailQuoteComponent } from "../po-email-quote/po-email-quote.component";
import { AddContactInformationComponent } from "../../../clients/components/add-contact-information/add-contact-information.component";
import { BuyerService } from "../../../../core/services/buyer.service";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DialogModule } from "primeng/dialog";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";
import { ClientContact } from "../../../../core/models/client/details/clientContact";
import { MenuModule } from "primeng/menu";
import { PanelModule } from "primeng/panel";
import {
  computeMinDate,
  toDateOrNull,
} from "../../../../core/utilities/mindate-function";

@UntilDestroy()
@Component({
  selector: "jni-quote-summary",
  templateUrl: "./quote-summary.component.html",
  styleUrls: ["./quote-summary.component.scss"],
  providers: [DatePipe, ConfirmationService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    DatePickerModule,
    SelectModule,
    PopoverModule,
    ShipToAddressComponent,
    ModalStackerComponent,
    QuoteNotesGridComponent,
    ConfirmDialogModule,
    QuoteNotesSidebarComponent,
    QuoteSummaryLineItemsComponent,
    SummaryInvoiceEmailsComponent,
    ClientDetailsComponent,
    PoEmailQuoteComponent,
    AddContactInformationComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    DialogModule,
    MenuModule,
    PanelModule,
  ],
})
export class QuoteSummaryComponent implements OnInit, OnChanges {
  @Input() saleOrderIdFromModal = "";
  @Input() isModal = false;
  @Output() clearShipToEvent = new EventEmitter();
  @Output() smallLoaderEvent = new EventEmitter<boolean>();
  @Output() customerBillToObjectEvent = new EventEmitter();
  @Output() getBuyerEvent = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  collapseStatus = false;
  expandStatus = true;
  collapseHeading = "Collapse all";
  quoteForm!: FormGroup;
  shipDate = "";
  inHandDate = "";
  quoteId = "";
  salesOrderLine: QuotesLineAddressDto[] = [];
  showSmallLoader = false;
  salesOrderStatusD365 = "";
  approvalStatusD365 = "";
  applyFeeCardStatus = "";
  foreignCurrency = "";
  currencyConversion!: ExchangeRatesDto;
  subTotal = "";
  net = "";
  gp = 0;
  commission = 0;
  gpPercentage = 0;
  oldEstimatedTax = 0;
  estimatedTax = 0;
  oldEstimatedFreight = 0;
  estimatedFreight = 0;
  orderTotal = 0;
  netGp = 0;
  netGpPercentage = 0;
  sumOfSellTotal = 0;
  loaderStatus = true;
  hiddenShipdate = true;
  hiddeninHanddate = true;
  estimatedTaxStatus = true;
  estimatedFreightStatus = true;
  selectedAccountNumber = "";
  customerLists: ClientSearchList[] = [];
  shippingProductsList: ShippingMethod[] = [];
  customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  applyCreditCardStatus = true;
  customerBillToObject!: ClientSearchList;
  countryRegionList: AddressCountryRegion[] = [];
  releasedProductsList: ReleasedProduct[] = [];
  bcProjectId = "";
  bacProjectId = "";
  percentageSign = "%";
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  brandingConsultantObject!: GetBCForSalesOrderDto;
  bacList: GetBacForSalesOrderDto[] = [];
  bacUserDefaultSelectionId = "";
  editHeaderStatus = false;
  showAddress = false;
  userPersonnelNumber!: string;
  shipDateCurrentdate!: Date;
  inHandDateCurrentdate!: Date;
  public customerVendor$ = new Subject<string>();
  recommendedTax = 0;
  isCustomerPoRequiredField = false;
  shiftToAddressList!: Address[];
  headerAddress!: Address;
  invoiceEmails: QuotesInvoiceEmail[] = [];
  selectedInvoiceEmail: InvoiceEmail[] = [];
  netCommissionStatus = false;
  bcPersonnelNumber = "";
  clientDisplayModal = false;
  proposalDisplayModal = false;
  customerId = "";
  quoteModalStatus = false;
  userObject!: GetUserDto;
  acceptedDate = "";
  rejectedDate = "";
  type = "";
  rejectionReason = false;
  salesOrderId = "";

  ClientAddresses: ClientAddressCustomize[] = [];
  clientContacts: Contact[] = [];

  reasonStatus = false;
  displaySidebar = false;
  collapseNotesStatus = true;
  expandNotesStatus = false;
  collapseNotesHeading = "Expand all";
  displayAddContact = false;
  addClientContact: AddClientContact = {} as AddClientContact;
  customerAccountNumber = "";
  partyNumber = "";
  buyerName = "";
  buyerLists: GetAllBuyersResponseDto[] = [];
  public buyerVendor$ = new Subject<string>();
  showAdresssLineFileds = true;
  quotesHeaderData!: QuotesHeaderAddressDto;
  showBacUserInputField = false;
  removedBacUser = "";
  showCopyButton = false;

  @ViewChild("shipTo", { static: false })
  shipTo!: ShipToAddressComponent;

  @ViewChild("quotenotes", { static: false })
  quotenotes!: QuoteNotesGridComponent;

  @ViewChild("quotesidebar", { static: false })
  quotesidebar!: QuoteNotesSidebarComponent;

  applyCreditCardList: ApplyCreditCard[] = [
    {
      id: 0,
      name: "Freight",
    },
    {
      id: 1,
      name: "BC Ledger",
    },
  ];

  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];

  formErrors: Record<string, string> = {
    jobName: "",
    brandingConsultant: "",
    methodOfPaymentHeader: "",
    customerId: "",
    shipDate: "",
    inHandsDate: "",
    addressSelectionName: "",
    countryRegionIdD365: "",
    customerPONumber: "",
    deliveryNameD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    jobName: {
      required: "Job name is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 300 characters.",
    },
    brandingConsultant: {
      required: "Branding consultant is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 50 characters.",
    },
    accountsCoordinator: {
      required: "Accounts coordinator is required.",
    },
    methodOfPaymentHeader: {
      required: "Payment method is required.",
    },
    customerId: {
      required: "Client/Lead is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandsDate: {
      required: "In-Hands date is required.",
    },
    addressSelectionName: {
      required: "Delivery is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    customerPONumber: {
      required: "Client PO Number is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
  };

  reason = [
    {
      id: 1,
      name: "Too Expensive",
    },
    {
      id: 2,
      name: "No Longer Need",
    },
    {
      id: 3,
      name: "Used Competitor",
    },
    {
      id: 4,
      name: "Did not like product",
    },
    {
      id: 5,
      name: "Cust Project Cancelled",
    },
    {
      id: 6,
      name: "Different Product",
    },
    {
      id: 7,
      name: "Other",
    },
  ];
  items: MenuItem[] = [];

  constructor(
    private _fb: FormBuilder,
    private _toastr: JniToastrService,
    private route: ActivatedRoute,
    private _loaderService: LoaderService,
    private _customerAccountService: CustomerAccountService,
    private _samplepoListingService: SamplepoListingService,
    private _createHeaderQuoteService: CreateHeaderQuoteService,
    private _router: Router,
    private _saleOrderService: SaleOrderService,
    private _addNewClientService: AddNewClientService,
    private _orderSummaryService: OrderSummaryService,
    private _profileFormService: ProfileFormService,
    private _clientDetailsService: ClientDetailsService,
    private _loginService: UserManagementService,
    public datepipe: DatePipe,
    private confirmationService: ConfirmationService,
    private renderer: Renderer2,
    private _quoteNotesSidebarService: QuoteNotesSidebarService,
    private _buyerService: BuyerService
  ) {
    this.initializeForm();
    this.route.params.subscribe(params => {
      this.quoteId = params["id"];
    });
  }

  ngOnInit(): void {
    this.disabledSaleOrderHeaderFields();
    this.getQuoteData(this.loaderStatus);
    this.getQuotesEmails();
    this.searchCustomerName();
    this.getMehtodPaymentListData();
    this.getCountryRegionListData();
    this.getAllReleaseProduct();
    this.getStateOfCollapseAll();
    this.getNotesStateOfCollapseAll();
    this.searchBuyerName();
    this.getAllBuyers();
    this.getUserProfile();
  }

  ngOnChanges() {
    if (this.saleOrderIdFromModal) {
      this.quoteId = this.saleOrderIdFromModal;
      this.quoteModalStatus = true;
    }
  }

  private initializeForm() {
    this.quoteForm = this._fb.group({
      orderHeader: this._fb.group({
        customerId: ["", Validators.required],
        jobName: ["", Validators.required],
        inHandsDate: ["", Validators.required], //inhands
        shipDate: [""],
        methodOfPaymentHeader: ["", Validators.required],
        brandingConsultant: ["", Validators.required],
        accountsCoordinator: ["", Validators.required],
        buyer: [""], // account co-ordinator
      }),
      customerAddress: this._fb.group({
        name: [""],
        address: [""],
        telephone: [""],
        billingAttentionD365: [""],
        billingLocationD365: [""],
      }),
      shipTo: this._fb.group({
        deliveryAddress: [""],
        attention: [""],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [""],
        cityD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: ["", Validators.required],
        purposeD365: [""],
        isPrimaryD365: "1",
        rSMJNIShipToEmailD365: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        saveAddress: [false],
        attentionInformationD365: [""],
        siteD365: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: 0,
        addressFormat: [""],
        validateAddress: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      orderDetails: this._fb.group({
        // buyer: [''],
        shippingMethod: [""],
        account: [""],
        foreignCurrency: [""],
        customerPONumber: [""],
        shippingMethodName: [""],
        methodOfPayment: [""],
        creditCardFeeCharge: 0,
        foreignCurrencyStatus: [false],
      }),
      estimatedOrderTotals: this._fb.group({
        recommendedTax: [0],
        estimatedTax: [0],
        estimatedFreight: [0],
        orderTotal: [0],
        invoiceEmail: [""],
      }),
      quoteStatus: this._fb.group({
        quotesId: [""],
        quoteAccepted: [""],
        quoteRejected: [""],
        reason: [""],
        quotesDateStatus: [""],
      }),
      invoicedEmail: this._fb.array([]),
    });
  }

  logValidationErrors(group: FormGroup = this.quoteForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  getAllReleaseProduct() {
    this._orderSummaryService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            x => x.itemNumberD365 != "Misc" && x.productTypeD365 === "Service"
          );
        },
      });
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  disabledSaleOrderHeaderFields() {
    this.quoteForm.get(["orderHeader", "customerId"])?.disable();
    this.quoteForm.get(["orderHeader", "buyer"])?.disable();
    this.quoteForm.get(["orderHeader", "jobName"])?.disable();
    this.quoteForm.get(["orderHeader", "brandingConsultant"])?.disable();
    this.quoteForm.get(["orderHeader", "accountsCoordinator"])?.disable();
    this.quoteForm.get(["orderHeader", "shipDate"])?.disable();
    this.quoteForm.get(["orderHeader", "inHandsDate"])?.disable();
    this.quoteForm.get(["orderHeader", "methodOfPaymentHeader"])?.disable();

    this.quoteForm.get(["customerAddress", "name"])?.disable();
    this.quoteForm.get(["customerAddress", "address"])?.disable();
    this.quoteForm.get(["customerAddress", "telephone"])?.disable();
    this.quoteForm.get(["customerAddress", "billingAttentionD365"])?.disable();
    this.quoteForm.get(["customerAddress", "billingLocationD365"])?.disable();

    this.quoteForm.get(["shipTo", "addressSelectionName"])?.disable();
    this.quoteForm.get(["shipTo", "attentionInformationD365"])?.disable();
    this.quoteForm.get(["shipTo", "streetD365"])?.disable();
    this.quoteForm.get(["shipTo", "locationD365"])?.disable();
    this.quoteForm.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.quoteForm.get(["shipTo", "zipCodeD365"])?.disable();
    this.quoteForm.get(["shipTo", "addressFormat"])?.disable();
    this.quoteForm.get(["shipTo", "addressD365"])?.disable();
    this.quoteForm.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.quoteForm.get(["shipTo", "buildingComplimentD365"])?.disable();
    this.quoteForm.get(["shipTo", "deliveryNameD365"])?.disable();
    this.quoteForm.get(["shipTo", "addressLine2"])?.disable();
    this.quoteForm.get(["shipTo", "addressLine3"])?.disable();
    this.quoteForm.get(["shipTo", "cityD365"])?.disable();
    this.quoteForm.get(["shipTo", "stateD365"])?.disable();
    this.quoteForm.get(["shipTo", "zipCodeD365"])?.disable();
    this.showAdresssLineFileds = false;

    // this.quoteForm.get(['orderDetails', 'buyer'])?.disable();
    this.quoteForm.get(["orderDetails", "customerPONumber"])?.disable();
    this.quoteForm.get(["orderDetails", "shippingMethod"])?.disable();
    this.quoteForm.get(["orderDetails", "foreignCurrency"])?.disable();
    this.quoteForm.get(["orderDetails", "creditCardFeeCharge"])?.disable();
    this.quoteForm.get(["orderDetails", "shippingMethodName"])?.disable();

    this.quoteForm.get(["estimatedOrderTotals", "recommendedTax"])?.disable();
    this.quoteForm.get(["estimatedOrderTotals", "orderTotal"])?.disable();
    this.quoteForm.get(["estimatedOrderTotals", "invoiceEmail"])?.disable();
    // this.quoteForm.get(['estimatedOrderTotals', 'quoteAccepted'])?.disable();
    // this.quoteForm.get(['estimatedOrderTotals', 'quoteRejected'])?.disable();
    // this.quoteForm.get(['estimatedOrderTotals', 'reason'])?.disable();

    this.updateButtonValidation = true;
    this.hiddenShipdate = true;
    this.hiddeninHanddate = true;
    this.estimatedTaxStatus = true;
    this.estimatedFreightStatus = true;
  }

  creditfee = 0;
  shippingMethodD365 = "";
  lastModifiedDate = "";
  createdDate = "";
  lastModifiedName = "";
  createdDateName = "";

  patchValuesInSaleOrderHeader(orderheader: QuotesHeader) {
    this.quoteForm.patchValue({
      orderHeader: {
        customerId: orderheader.customerIdD365,
        jobName: orderheader.jobNameD365,
        brandingConsultant: orderheader.brandingConsultantD365,
        accountsCoordinator: orderheader.accountsCoordinatorD365,
        methodOfPaymentHeader: orderheader.methodOfPaymentD365,
        buyer: orderheader.buyerD365,
      },
      orderDetails: {
        // buyer: orderheader.buyerD365,
        shippingMethod: orderheader.shippingMethodD365,
        foreignCurrency: orderheader.foreignCurrencyD365,
        customerPONumber: orderheader.customerPONumberD365,
      },
      customerAddress: {
        billingAttentionD365: orderheader.billToAttentionInformationD365,
        billingLocationD365: orderheader.billToLocationD365,
      },
    });
    this.bcPersonnelNumber = orderheader?.brandingConsultantD365 ?? "";
    this.netCommissionVisibleForBC(this.userObject);
    this.creditfee = orderheader.creditCardFeeChargeD365;
    this.shippingMethodD365 = orderheader.shippingMethodD365 ?? "";
    this.getAllShippingMethod();
    this.getCreditCard({
      value: orderheader.methodOfPaymentD365 ?? "",
    } as SelectChangeEvent);
    if (orderheader.lastModifiedDate) {
      this.lastModifiedDate = orderheader.lastModifiedDate;
      const modifiedNameList = orderheader?.lastModifiedBy?.split("@");
      if (modifiedNameList && modifiedNameList.length > 1) {
        this.lastModifiedName = modifiedNameList[0];
      }
    }
    if (orderheader.createdDate) {
      this.createdDate = orderheader.createdDate;
      const createdByList = orderheader?.createdBy.split("@");
      if (createdByList.length > 1) {
        this.createdDateName = createdByList[0];
      }
    }
  }

  patchValuesInSaleOrderHeaderAddress(
    orderHeaderAddress: Address,
    orderHeader: QuotesHeader
  ) {
    this.quoteForm.patchValue({
      shipTo: {
        //addressSelectionName: orderHeader.addressSelectionD365,
        streetD365: orderHeaderAddress.streetD365,
        attentionInformationD365: orderHeader.attentionInformationD365,
        locationD365: orderHeader.locationD365,
        rSMJNIShipToEmailD365: orderHeader.rsmjniShipToEmail,
        shipToPhone: orderHeader.shipToPhone,
        countryRegionIdD365: orderHeaderAddress.countryRegionIdD365,
        zipCodeD365: orderHeaderAddress.zipCodeD365,
        cityD365: orderHeaderAddress.cityD365,
        stateD365: orderHeaderAddress.stateD365,
        buildingComplimentD365: orderHeaderAddress.buildingComplimentD365,
        postBoxD365: orderHeaderAddress.postBoxD365,
        countyD365: orderHeaderAddress.countyD365,
        streetNumberD365: orderHeaderAddress.streetNumberD365,
        districtNameD365: orderHeaderAddress.districtNameD365,
        addressLocationNumber: orderHeader.addressLocationNumberD365 ?? 0,
        addressD365: orderHeaderAddress?.addressD365?.replace("<br/>", "\n"),
      },
    });
    this.patchValueInaddressSelection(orderHeader.addressSelectionD365 ?? "");
    this.getOneTimeAddress();
  }

  patchValueInaddressSelection(addressSelectionName: string) {
    let addressBook = "";
    if (addressSelectionName.toLowerCase().includes("address book")) {
      addressBook = "Client Address Book";
      this.shipTo.shipToAddress = true;
      this.shipTo.clientShipToAddressDisabled = true;
    } else if (addressSelectionName.toLowerCase().includes("bill to")) {
      addressBook = "Bill To";
      this.shipTo.billToFieldName = true;
    } else {
      addressBook = addressSelectionName;
    }
    this.quoteForm.patchValue({
      shipTo: {
        addressSelectionName: addressBook,
      },
    });
  }

  invoiceEmail: QuotesInvoiceEmail[] = [];

  patchValuesInInvoiceEmail(invoiceEmail: QuotesInvoiceEmail[]) {
    this.invoiceEmails = invoiceEmail;
    this.invoiceEmail = [];
    let commonSeparatedEmail = "";
    invoiceEmail.forEach(x => {
      if (x.invoice) {
        commonSeparatedEmail += x.email + "\n";
        this.invoiceEmail.push(x);
      }
    });
    if (commonSeparatedEmail) {
      this.quoteForm.patchValue({
        estimatedOrderTotals: {
          invoiceEmail: commonSeparatedEmail.slice(0, -1),
        },
      });
    }
  }

  getQuoteData(getloaderStatus: boolean) {
    this._loaderService.setLoaderState(getloaderStatus);
    this._createHeaderQuoteService
      .getQuotesData(this.quoteId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.populateMenuItem();
            if (res?.data?.salesOrderHeader) {
              this.quotesHeaderData = res.data.salesOrderHeader;
            }
            if (res.data.salesOrderHeader?.address) {
              this.headerAddress = res?.data?.salesOrderHeader?.address;
            }
            if (res.data.salesOrderHeader?.salesOrderHeader) {
              this.patchValuesInSaleOrderHeader(
                res.data.salesOrderHeader.salesOrderHeader
              );

              if (res.data.salesOrderHeader?.salesOrderHeader?.account) {
                this.patchValueInAccount(
                  res.data.salesOrderHeader.salesOrderHeader.account
                );
              }

              this.customerAccountNumber =
                res.data.salesOrderHeader.salesOrderHeader.customerIdD365 ?? "";
              this.getAllBuyers();
              // this.patchValuesInInvoiceEmail(res.data.invoiceEmail || []);
              if (
                res?.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
                  ?.toLowerCase()
                  ?.includes("multi")
              ) {
                this.patchValueInDeliveryName("Multiple Drop Ships");
              } else if (
                res?.data?.salesOrderHeader?.salesOrderHeader?.addressSelectionD365
                  ?.toLowerCase()
                  ?.includes("tbd")
              ) {
                this.patchValueInDeliveryName("TBD");
              } else {
                this.patchValueInDeliveryName(
                  res.data.salesOrderHeader.salesOrderHeader.deliveryNameD365 ||
                    ""
                );
              }
              if (res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365) {
                this.getCustomerDetail(
                  res.data.salesOrderHeader.salesOrderHeader.customerIdD365
                );
                this.isCustomerPOFieldRequired(
                  res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                );
              }
              this.getSellCurrencyConversion(
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.foreignCurrencyD365 ?? ""
              );

              if (res.data.salesOrderHeader?.salesOrderHeader?.quotesStatus) {
                this.salesOrderStatusD365 =
                  res.data.salesOrderHeader.salesOrderHeader.quotesStatus;
              }

              if (
                res.data.salesOrderHeader?.salesOrderHeader?.approvalStatusD365
              ) {
                this.approvalStatusD365 =
                  res.data.salesOrderHeader.salesOrderHeader.approvalStatusD365;
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader?.methodOfPaymentD365
              ) {
                this.applyFeeCardStatus =
                  res.data.salesOrderHeader.salesOrderHeader.methodOfPaymentD365;
              }
              const shipOrgDate = toDateOrNull(
                res.data.salesOrderHeader?.salesOrderHeader?.shipDateD365
              );
              if (shipOrgDate) {
                this.shipDate =
                  this.datepipe.transform(shipOrgDate, "MM/dd/yyyy") ?? "";
                this.quoteForm.patchValue({
                  orderHeader: {
                    shipDate: this.shipDate,
                  },
                });
              }
              const inHandOrgDate = toDateOrNull(
                res.data.salesOrderHeader?.salesOrderHeader?.inHandsDateD365
              );
              if (inHandOrgDate) {
                this.inHandDate =
                  this.datepipe.transform(inHandOrgDate, "MM/dd/yyyy") ?? "";
                this.quoteForm.patchValue({
                  orderHeader: {
                    inHandsDate: this.inHandDate,
                  },
                });
              }
              let candidate: Date | null = null;
              if (shipOrgDate && inHandOrgDate) {
                candidate =
                  new Date(
                    inHandOrgDate.getFullYear(),
                    inHandOrgDate.getMonth(),
                    inHandOrgDate.getDate()
                  ) <
                  new Date(
                    shipOrgDate.getFullYear(),
                    shipOrgDate.getMonth(),
                    shipOrgDate.getDate()
                  )
                    ? inHandOrgDate
                    : shipOrgDate;
              } else {
                candidate = shipOrgDate ?? inHandOrgDate ?? null;
              }
              this.shipDateCurrentdate = computeMinDate(shipOrgDate);
              this.inHandDateCurrentdate = computeMinDate(candidate);
              if (res.data.salesOrderHeader.salesOrderHeader.quoteAccepted) {
                const quoteAccepted = new Date(
                  res.data.salesOrderHeader.salesOrderHeader.quoteAccepted
                );
                const acceptedDate =
                  this.datepipe.transform(quoteAccepted, "MM/dd/yyyy") ?? "";
                this.quoteForm.patchValue({
                  quoteStatus: {
                    quoteAccepted: acceptedDate,
                    reason:
                      res.data?.salesOrderHeader?.salesOrderHeader
                        ?.rejectionReason ?? "",
                  },
                });
              }
              if (res.data.salesOrderHeader.salesOrderHeader.quotesDateStatus) {
                this.quoteForm.patchValue({
                  quoteStatus: {
                    quotesDateStatus:
                      res.data.salesOrderHeader.salesOrderHeader
                        .quotesDateStatus,
                  },
                });
              }
              if (res.data.salesOrderHeader.salesOrderHeader.quoteRejected) {
                this.reasonStatus = true;
                const quoteRejected = new Date(
                  res.data.salesOrderHeader.salesOrderHeader.quoteRejected
                );
                const rejectedDate =
                  this.datepipe.transform(quoteRejected, "MM/dd/yyyy") ?? "";
                this.quoteForm.patchValue({
                  quoteStatus: {
                    quoteRejected: rejectedDate,
                    reason:
                      res.data?.salesOrderHeader?.salesOrderHeader
                        ?.rejectionReason ?? "",
                  },
                });
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader?.estimatedTaxD365
              ) {
                this.estimatedTax =
                  res.data.salesOrderHeader?.salesOrderHeader?.estimatedTaxD365;
                this.quoteForm.patchValue({
                  estimatedOrderTotals: {
                    estimatedTax: this.estimatedTax,
                  },
                });
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader?.recommendedTaxD365
              ) {
                this.recommendedTax =
                  res.data.salesOrderHeader?.salesOrderHeader?.recommendedTaxD365;
                this.quoteForm.patchValue({
                  estimatedOrderTotals: {
                    recommendedTax: this.recommendedTax,
                  },
                });
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.estimatedFreightD365
              ) {
                this.estimatedFreight =
                  res.data.salesOrderHeader?.salesOrderHeader?.estimatedFreightD365;
                this.quoteForm.patchValue({
                  estimatedOrderTotals: {
                    estimatedFreight: this.estimatedFreight,
                  },
                });
                this.calculateOrderTotal();
              }
              if (
                !res.data.salesOrderHeader?.salesOrderHeader?.orderTotalD365
              ) {
                this.calculateSumOfSellTotalBeforeEdit(
                  res?.data?.salesOrderLine
                );
              }
            }

            if (
              res.data.salesOrderHeader?.address &&
              res.data.salesOrderHeader?.salesOrderHeader
                ?.addressSelectionD365 &&
              !(
                res.data.salesOrderHeader.salesOrderHeader.addressSelectionD365
                  .toLowerCase()
                  .includes("multi") ||
                res.data.salesOrderHeader.salesOrderHeader.addressSelectionD365
                  .toLowerCase()
                  .includes("tbd")
              )
            ) {
              this.patchValuesInSaleOrderHeaderAddress(
                res.data.salesOrderHeader.address,
                res.data.salesOrderHeader?.salesOrderHeader
              );
            } else {
              this.patchValueInAddressD365(
                res.data.salesOrderHeader?.salesOrderHeader ??
                  ({} as QuotesHeader)
              );
            }
            this.patchValuesInAttentionLocation(
              res.data.salesOrderHeader?.salesOrderHeader
                ?.attentionInformationD365 ?? "",
              res.data.salesOrderHeader?.salesOrderHeader?.locationD365 ?? "",
              res.data.salesOrderHeader?.salesOrderHeader?.rsmjniShipToEmail ??
                ""
            );
            if (res.data.salesOrderLine) {
              if (res.data.salesOrderLine.length > 0) {
                this.salesOrderLine = res.data?.salesOrderLine;
                if (
                  this.foreignCurrency &&
                  this.foreignCurrency.toLowerCase() !== "usd"
                ) {
                  this.calculateNetAfterCurrencyConvert();
                  this.calculateNetGpAfterCurrencyConvert();
                } else {
                  this.calculateNet();
                  this.calculateNetGp();
                }

                this.calculateSubTotal();
                this.calculateSumOfSellTotal();
              }
            }
          } else {
            this._toastr.error("Error", res.message || "Data not found");
          }

          this.showCopyButton = true;
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  getQuotesEmails() {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .getQuotesEmails(this.quoteId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.patchValuesInInvoiceEmail(res.data || []);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  patchValueInAddressD365(salesOrderHeader: QuotesHeader) {
    let addressBook = "";
    if (
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .includes("address book")
    ) {
      addressBook = "Client Address Book";
    } else if (
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .toLowerCase()
        .includes("bill to")
    ) {
      addressBook = "Bill To";
    } else if (
      salesOrderHeader?.addressSelectionD365?.toLowerCase().includes("one time")
    ) {
      addressBook = "One Time";
    } else if (
      salesOrderHeader?.addressSelectionD365
        ?.toLowerCase()
        .includes("multi ship") ||
      salesOrderHeader?.addressSelectionD365?.toLowerCase().includes("drop") ||
      salesOrderHeader?.addressSelectionD365?.toLowerCase().includes("multi")
    ) {
      addressBook = "Multi Ship To";
    } else if (
      salesOrderHeader?.addressSelectionD365?.toLowerCase()?.includes("tbd")
    ) {
      addressBook = "TBD";
    } else {
      addressBook = salesOrderHeader?.addressSelectionD365 ?? "";
    }
    this.quoteForm.patchValue({
      shipTo: {
        addressSelectionName: addressBook,
      },
    });
  }

  patchValuesInAttentionLocation(
    attention: string,
    location: string,
    rsmjniShipToEmail: string
  ) {
    this.quoteForm.patchValue({
      shipTo: {
        locationD365: location,
        attentionInformationD365: attention,
        rSMJNIShipToEmailD365: rsmjniShipToEmail,
      },
    });
  }

  isCustomerPOFieldRequired(accountNumber: string) {
    this._clientDetailsService
      .IsCustomerPOFieldRequired(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.setCustomerPoRequiredField();
          } else {
            this.removeCustomerPoRequiredField();
          }
        },
        error: res => {
          this._toastr.error(res.message, "Error");
        },
      });
  }

  patchValueInDeliveryName(name: string) {
    this.quoteForm.patchValue({
      shipTo: {
        deliveryNameD365: name,
      },
    });
  }

  setCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = true;
    this.quoteForm
      .get(["orderDetails", "customerPONumber"])
      ?.setValidators(Validators.required);
    this.quoteForm
      .get(["orderDetails", "customerPONumber"])
      ?.updateValueAndValidity();
  }

  removeCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = false;
    this.quoteForm.get(["orderDetails", "customerPONumber"])?.clearValidators();
    this.quoteForm
      .get(["orderDetails", "customerPONumber"])
      ?.updateValueAndValidity();
  }

  getAllBcUsers(bcname: string, bacname: string) {
    this._samplepoListingService
      .getAllBrandingConsultant()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.brandingConsultantLists = res.data;
            const bcObject = res.data.filter(
              (x: GetUserProjectDto) => x.personnelNumber === bcname
            );
            if (bcObject.length > 0) {
              this.bcProjectId = bcObject[0].personnelNumber;
              this.quoteForm.patchValue({
                orderHeader: {
                  brandingConsultant: bcObject[0].projectName,
                },
              });
              this.getBACList(bcObject[0].id, bacname);
            }
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getBACList(id: number, bacname: string) {
    this._orderSummaryService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.bacList = res.data as unknown as GetBacForSalesOrderDto[];

            const bac = res.data.filter(
              (x: UsersList) => x.personnelNumber === bacname
            );
            if (bac.length > 0) {
              this.bacProjectId = bac[0].personnelNumber;
              this.bacUserDefaultSelectionId = this.bacProjectId;
            }
          }
        },
      });
  }

  getBACNewList(id: number, bacname: string) {
    this._orderSummaryService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.bacList = res.data as unknown as GetBacForSalesOrderDto[];

            const bac = res.data.filter(
              (x: UsersList) => x.personnelNumber === bacname
            );
            if (bac.length > 0) {
              this.bacProjectId = bac[0].personnelNumber;
              this.bacUserDefaultSelectionId = this.bacProjectId;
            }
          }
        },
      });
  }

  getSellCurrencyConversion(currency: string) {
    this.foreignCurrency = currency;
    this.showSmallLoader = true;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  getCustomerDetail(customerAccountNumber: string) {
    this._createHeaderQuoteService
      .getCustomerByNameAndAccountNumberFilter(
        customerAccountNumber,
        this.quoteId
      )
      .subscribe({
        next: res => {
          if (res.data) {
            this.customerBillToObject = res.data[0];
            this.patchValueInCustomerDetail(res.data[0]);
            this.partyNumber = res?.data[0]?.partyNumber ?? "";
            this.patchValueInCustomerAddressField(
              res?.data[0]?.partyNumber ?? "",
              customerAccountNumber
            );
            this.getAllContactsByAccountNumber(
              customerAccountNumber,
              res?.data[0]?.partyNumber ?? ""
            );
            const bcPersonnelNumber = this.quoteForm.get([
              "orderHeader",
              "brandingConsultant",
            ])?.value;

            this.getBCForSalesOrder(
              this.customerBillToObject?.clientAccount,
              bcPersonnelNumber,
              ""
            );
            if (this.customerBillToObject?.name) {
              this.shipTo.billToAddressField =
                this.customerBillToObject.name || "";
            }
          }
        },
      });
  }

  patchValueInCustomerDetail(customerObject: ClientSearchList) {
    this.quoteForm.patchValue({
      customerAddress: {
        name: customerObject?.organizationNameD365,
        telephone: customerObject?.locator,
      },
    });
  }

  patchValueInCustomerAddressField(partyNumber: string, accountNumber: string) {
    this._customerAccountService
      .getCustomerAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.shiftToAddressList = res.data;
          if (this.shiftToAddressList.length > 0 && this.headerAddress) {
            const address = this.shiftToAddressList?.filter(
              (x: Address) =>
                x.addressD365 === this.headerAddress?.addressD365 &&
                x.locationNumberD365?.toString() ===
                  this.headerAddress?.locationNumberD365?.toString()
            );
            if (address?.length > 0) {
              this.shipTo.shiftToAddressField =
                address[0]?.descriptionD365 ?? "";
            }
          }

          const primaryAddress = res.data.filter(
            (x: Address) =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInCustomerFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          }
        },
      });
  }

  patchValuesInCustomerFormAddressField(address: string) {
    this.quoteForm.patchValue({
      customerAddress: {
        address: address,
      },
    });
  }

  calculateNet() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365?.toString() ?? ""
                )
              : parseFloat(
                  next?.salesOrderLine?.netTotalD365?.toString() ?? "0"
                ))
          );
        },
        0
      );
      this.net = total.toString();
    }
  }

  calculateNetGp() {
    if (this.salesOrderLine.length > 0) {
      const netTotal = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365?.toString() ?? ""
                )
              : parseFloat(
                  next?.salesOrderLine?.netTotalD365?.toString() ?? ""
                ))
          );
        },
        0
      );
      const sellTotal = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine.sellTotalD365.toString())
              : 0)
          );
        },
        0
      );
      const serviceFee = 0.025 * sellTotal;
      this.netGp = sellTotal - netTotal - serviceFee;
      this.calculateNetProfitPercentage(this.netGp, sellTotal);
      this.calculateCommission(this.netGp);
    }
  }

  calculateNetProfitPercentage(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / Math.abs(sellTotal)) * 100;
      this.netGpPercentage = gpPercentage;
    }
  }

  calculateCommission(gp: number) {
    if (this.salesOrderLine.length > 0) {
      this.commission = gp * 0.5;
    }
  }

  calculateNetAfterCurrencyConvert() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365?.toString() ?? ""
                )
              : parseFloat(
                  next?.salesOrderLine?.netTotalD365?.toString() ?? ""
                ))
          );
        },
        0
      );
      this.net = total.toString();
    }
  }

  calculateNetGpAfterCurrencyConvert() {
    if (this.salesOrderLine.length > 0) {
      const netTotal = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next?.salesOrderLine?.isnetInForeignCurrencyStatus
              ? parseFloat(
                  next?.salesOrderLine?.netConversionTotalD365?.toString() ?? ""
                )
              : parseFloat(
                  next?.salesOrderLine?.netTotalD365?.toString() ?? ""
                ))
          );
        },
        0
      );
      const sellTotal = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellConversionTotal
              ? parseFloat(
                  next.salesOrderLine.sellConversionTotal.toString() ?? ""
                )
              : 0)
          );
        },
        0
      );
      const serviceFee = 0.025 * sellTotal;
      this.netGp = sellTotal - netTotal - serviceFee;
      this.calculateNetProfitPercentageAfterConvert(this.netGp, sellTotal);
      this.calculateCommissionAfterConvert(this.netGp);
    }
  }

  calculateCommissionAfterConvert(gp: number) {
    if (this.salesOrderLine.length > 0) {
      this.commission = gp * 0.5;
    }
  }

  calculateNetProfitPercentageAfterConvert(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / Math.abs(sellTotal)) * 100;
      this.netGpPercentage = gpPercentage;
    }
  }

  getInfinity(percentage: number) {
    if (Number.isFinite(percentage)) {
      return true;
    } else {
      return false;
    }
  }

  calculateSubTotal() {
    if (this.salesOrderLine.length > 0) {
      const total = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine.sellTotalD365.toString())
              : 0)
          );
        },
        0
      );
      this.subTotal = total.toString();
      this.calculateOrderTotal();
    }
  }

  calculateGrossProfitPercentage(gp: number, sellTotal: number) {
    if (this.salesOrderLine.length > 0) {
      const gpPercentage = (gp / sellTotal) * 100;
      this.gpPercentage = gpPercentage;
    }
  }

  refreshPage(event: boolean) {
    if (event) {
      this.getQuoteData(false);
    }
  }

  setAllCollapseAll() {
    this.collapseStatus = false;
    this.expandStatus = true;
    this.collapseHeading = "Collapse all";
    this.collapseNotesStatus = false;
    this.expandNotesStatus = true;
    this.collapseNotesHeading = "Collapse all";
  }

  onToggle() {
    if (this.expandStatus) {
      this.collapseStatus = true;
      this.expandStatus = false;
      this.setStateOfExpandAll();
      this.collapseHeading = "Expand all";
    } else {
      this.collapseStatus = false;
      this.expandStatus = true;
      this.setStateOfCollapseAll();
      this.collapseHeading = "Collapse all";
    }
  }

  proposalStatus = false;

  onQuoteConvert() {
    this.proposalStatus = false;
    const QuoteFormObject: ConvertToSaleOrderDto = {
      quoteId: this.quoteId,
    };
    if (this.customerBillToObject?.clientType?.toLowerCase() === "prospect") {
      this.confirmationService.confirm({
        message:
          "To create the order, you must first convert your Lead to a customer?",
        accept: () => {
          this._router.navigateByUrl(
            `prospects/All/prospects-detail/${this.customerBillToObject?.clientAccount}`,
            {
              state: { quoteId: this.quoteId },
            }
          );
        },
      });
      return;
    }

    this._loaderService.setLoaderState(true);
    if (this.quoteId) {
      this._createHeaderQuoteService
        .convertQuotesToSaleOrder(QuoteFormObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.salesOrderId = res.data.SalesOrderId ?? "";
              this.proposalStatus = true;
              this.convertedOrderNotes();
              this._toastr.success(
                "Success",
                res.message || "Proposal convert Successfully"
              );
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error converting proposal"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error converting proposal"
            );
          },
        });
    }
  }

  updateButtonValidation = true;
  onEdit() {
    if (this.showBacUserInputField === true) {
      this.showBacUserInputField = false;
      this.bacUserDefaultSelectionId = "";
      this.quoteForm.patchValue({
        orderHeader: {
          accountsCoordinator: "",
        },
      });

      this.quoteForm.get(["orderHeader", "accountsCoordinator"])?.enable();

      const accountsCoordinatorControl = this.quoteForm.get([
        "orderHeader",
        "accountsCoordinator",
      ]);
      accountsCoordinatorControl?.markAsTouched();
      accountsCoordinatorControl?.markAsDirty();
      this.logValidationErrors();
    }
    this.editHeaderStatus = true;
    this.quoteForm.get(["orderHeader", "customerId"])?.enable();
    this.quoteForm.get(["orderHeader", "buyer"])?.enable();
    this.quoteForm.get(["orderHeader", "jobName"])?.enable();
    this.quoteForm.get(["orderHeader", "shipDate"])?.enable();
    this.quoteForm.get(["orderHeader", "inHandsDate"])?.enable();
    this.quoteForm.get(["orderHeader", "methodOfPaymentHeader"])?.enable();

    this.quoteForm.get(["shipTo", "addressSelectionName"])?.enable();
    this.quoteForm.get(["shipTo", "attentionInformationD365"])?.enable();
    this.quoteForm.get(["shipTo", "streetD365"])?.enable();
    this.quoteForm.get(["shipTo", "locationD365"])?.enable();
    this.quoteForm.get(["shipTo", "countryRegionIdD365"])?.enable();
    this.quoteForm.get(["shipTo", "zipCodeD365"])?.enable();
    this.quoteForm.get(["shipTo", "addressD365"])?.enable();
    this.quoteForm.get(["shipTo", "addressFormat"])?.enable();
    this.quoteForm.get(["shipTo", "buildingComplimentD365"])?.enable();
    this.quoteForm.get(["shipTo", "rSMJNIShipToEmailD365"])?.enable();
    this.quoteForm.get(["shipTo", "deliveryNameD365"])?.enable();
    this.quoteForm.get(["shipTo", "addressFormat"])?.enable();
    this.quoteForm.get(["shipTo", "addressLine2"])?.enable();
    this.quoteForm.get(["shipTo", "addressLine3"])?.enable();
    this.quoteForm.get(["shipTo", "cityD365"])?.enable();
    this.quoteForm.get(["shipTo", "stateD365"])?.enable();
    this.quoteForm.get(["shipTo", "zipCodeD365"])?.enable();

    // this.quoteForm.get(['orderDetails', 'buyer'])?.enable();
    this.quoteForm.get(["orderDetails", "customerPONumber"])?.enable();
    this.quoteForm.get(["orderDetails", "shippingMethod"])?.enable();
    this.quoteForm.get(["orderDetails", "creditCardFeeCharge"])?.enable();

    this.quoteForm.get(["orderHeader", "brandingConsultant"])?.enable();
    this.quoteForm.get(["orderHeader", "accountsCoordinator"])?.enable();

    // this.quoteForm.get(['estimatedOrderTotals', 'quoteAccepted'])?.enable();
    // this.quoteForm.get(['estimatedOrderTotals', 'quoteRejected'])?.enable();
    // this.quoteForm.get(['estimatedOrderTotals', 'reason'])?.enable();

    this.hiddenShipdate = false;
    this.hiddeninHanddate = false;
    this.updateButtonValidation = false;
    this.estimatedTaxStatus = false;
    this.estimatedFreightStatus = false;
    this.shipTo.onDeliveryAddressChange(
      this.quoteForm.get(["shipTo", "addressSelectionName"])?.value,
      false
    );

    this.setAllCollapseAll();
  }

  onHeaderUpdate() {
    this._loaderService.setLoaderState(true);
    const quoteFormObject =
      this.quoteForm.getRawValue() as UpdateQuotesHeaderDto;

    if (quoteFormObject.orderHeader && !quoteFormObject.orderHeader?.shipDate) {
      quoteFormObject.orderHeader.shipDate = "";
    }

    // if (!quoteFormObject['shipTo']?.streetD365) {
    //   if (
    //     quoteFormObject['shipTo']?.addressSelectionName?.toLowerCase() !==
    //       'tbd' &&
    //     !(
    //       quoteFormObject['shipTo']?.addressSelectionName?.toLowerCase() ==
    //         'multi ship to' ||
    //       quoteFormObject['shipTo']?.addressSelectionName?.toLowerCase() ==
    //         'multiple ship-to' ||
    //       quoteFormObject['shipTo']?.addressSelectionName
    //         ?.toLowerCase()
    //         .includes('drop')
    //     )
    //   ) {
    //     this._toastr.error('Error', 'Address is required');
    //     this._loaderService.setLoaderState(false);
    //     return;
    //   }
    // }

    // if (
    //   quoteFormObject['orderHeader'] &&
    //   !quoteFormObject['orderHeader']?.inHandsDate
    // ) {
    //   quoteFormObject['orderHeader'].inHandsDate = '';
    // }

    if (
      quoteFormObject.estimatedOrderTotals &&
      !quoteFormObject.estimatedOrderTotals?.quoteAccepted
    ) {
      quoteFormObject.estimatedOrderTotals.quoteAccepted = "";
    }
    if (
      quoteFormObject.estimatedOrderTotals &&
      !quoteFormObject.estimatedOrderTotals?.quoteRejected
    ) {
      quoteFormObject.estimatedOrderTotals.quoteRejected = "";
    }

    if (
      quoteFormObject.orderHeader?.shipDate &&
      quoteFormObject.orderHeader?.inHandsDate
    ) {
      if (
        new Date(quoteFormObject.orderHeader?.inHandsDate) <
        new Date(quoteFormObject.orderHeader?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date header greater and equal to ship date header"
        );
        return;
      }
    }

    if (this.bcProjectId && quoteFormObject.orderHeader) {
      quoteFormObject.orderHeader.brandingConsultant = this.bcProjectId;
    }

    if (
      this.bacProjectId &&
      quoteFormObject.orderHeader &&
      this.bacUserDefaultSelectionId
    ) {
      quoteFormObject.orderHeader.accountsCoordinator = this.bacProjectId;
    }

    if (!this.bacUserDefaultSelectionId && quoteFormObject.orderHeader) {
      quoteFormObject.orderHeader.accountsCoordinator = "";
    }

    // if (
    //   quoteFormObject.shipTo &&
    //   quoteFormObject.shipTo.addressSelectionName?.toLowerCase().includes('one')
    // ) {
    //   quoteFormObject.shipTo.addressLocationNumber = 0;
    // }

    if (quoteFormObject.orderDetails != null) {
      quoteFormObject.orderDetails.methodOfPayment =
        quoteFormObject.orderHeader?.methodOfPaymentHeader;
    }

    if (quoteFormObject.shipTo) {
      const formValue = this.quoteForm.getRawValue();
      const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
      quoteFormObject.shipTo.deliveryAddressD365 = this.getDeliveryAddress(
        quoteFormObject.shipTo.addressSelectionName ?? "",
        quoteFormObject.shipTo.deliveryNameD365 ?? "",
        value ?? ""
      );
    }

    if (quoteFormObject?.orderDetails && quoteFormObject.orderHeader) {
      quoteFormObject.orderDetails.buyer = quoteFormObject.orderHeader.buyer;
    }

    if (this.quoteId) {
      quoteFormObject.quotesId = this.quoteId;
      this._createHeaderQuoteService
        .updateQuoteHeaderData(quoteFormObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this._toastr.success("Success", "Proposal update successfully");
              this.getQuoteData(true);
              this.disabledSaleOrderHeaderFields();
              //this.orderNotes();
              this.editHeaderStatus = false;
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error updating proposal"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error updating proposal"
            );
          },
        });
    }
  }

  orderNotes() {
    const acceptedDate = this.quoteForm.get([
      "quoteStatus",
      "quoteAccepted",
    ])?.value;
    const rejectedDate = this.quoteForm.get([
      "quoteStatus",
      "quoteRejected",
    ])?.value;
    const orderNotes = this.quoteForm.get(["quoteStatus", "quotesDateStatus"])
      ?.value as string;

    if (orderNotes && orderNotes.toLowerCase() === "accepted") {
      const notesObject = {
        salesOrderId: this.quoteId,
        portalKey: uuidv4(),
        type: "Proposal",
        note: "Accepted " + acceptedDate,
        description: "Proposal Accepted",
      } as QuotesNotes;
      this.onQuoteNotesSave(notesObject);
    } else if (orderNotes && orderNotes.toLowerCase() === "rejected") {
      const reason = this.quoteForm.get(["quoteStatus", "reason"])?.value;
      const notesObject = {
        salesOrderId: this.quoteId,
        portalKey: uuidv4(),
        type: "Proposal",
        description: "Rejected",
        note: reason + " " + rejectedDate,
      } as QuotesNotes;
      this.onQuoteNotesSave(notesObject);
    }
  }

  onCustomerSearchOpenToggle(mydrop: Popover, event: KeyboardEvent) {
    mydrop.show(event);
    // if (event?.target.value != '') {
    //   this.deliveryAddress[1].status = false;
    //   this.deliveryAddress[2].status = false;
    // } else {
    //   this.deliveryAddress[1].status = true;
    //   this.deliveryAddress[2].status = true;
    // }
  }

  searchCustomerName() {
    this.customerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          const accountNumberOrName = searchitem;
          this.customerLists = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._customerAccountService.getCustomerByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.customerLists = res.data;
          }
        },
      });
  }

  getCustomerAccount(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const eventTarget = event.target as HTMLInputElement;
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key.toLowerCase() == "tab") {
      const countryValue = eventTarget.value;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter(countryValue)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.customerLists = res.data;
            if (this.customerLists.length > 0) {
              this.onClientSelection(this.customerLists[0], mydrop);
              this.clearShipToEvent.emit();
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onClientSelection(event: ClientSearchList, clientProspetToggle: Popover) {
    this.selectedAccountNumber = event.clientAccount;
    this.patchValueInCurrency(event.currencyD365);

    this.quoteForm.patchValue({
      orderHeader: {
        customerId: event.clientAccount,
      },
      customerAddress: {
        name: event.organizationNameD365,
        telephone: event.locator,
        billingAttentionD365: event.billingAttentionD365,
        billingLocationD365: event.billingLocationD365,
      },
    });
    if (this.selectedAccountNumber) {
      this.getAllBuyers();
      this.patchValueInCustomerAddressField(
        event.partyNumber ?? "",
        this.selectedAccountNumber
      );
    }
    this.isCustomerPOFieldRequired(this.selectedAccountNumber);
    this.customerBillToObject = event;

    this.getBCForSalesOrder(
      event.clientAccount,
      event.bcPersonnelNumberD365 ?? "",
      "edit"
    );
    clientProspetToggle.hide();

    const delivery = this.quoteForm.get([
      "shipTo",
      "addressSelectionName",
    ])?.value;
    if (
      delivery === "Bill To" ||
      delivery === "Bill to" ||
      delivery === "Client Address Book" ||
      delivery === "Client address book" ||
      delivery == "Address book" ||
      delivery == "To address book"
    ) {
      this.shipTo.clearNewShifToForm();
    }
  }

  getBCForSalesOrder(
    accountNumber: string,
    bcPersonnelNumber: string,
    status: string
  ) {
    this._saleOrderService
      .getBCForSalesOrder(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;

            const filterBcObject = this.brandingConsultantLists.filter(
              x => x.personnelNumber === bcPersonnelNumber
            );
            if (filterBcObject.length > 0) {
              this.bcProjectId = filterBcObject[0].personnelNumber;
              this.patchValueInBrandingConsultant(
                filterBcObject[0].projectName
              );
            } else {
              this.patchValueInBrandingConsultant("");
            }
            if (status === "edit") {
              this.getBacForSaleOrderEdit(filterBcObject[0]?.personnelNumber);
            } else {
              this.getBacForSalesOrder(filterBcObject[0]?.personnelNumber);
            }
          }
        },
      });
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            const findBac = res.data.find(
              x =>
                x.personnelNumber ===
                this.quotesHeaderData.salesOrderHeader?.accountsCoordinatorD365
            );
            if (!findBac) {
              this.showBacUserInputField = true;
              this.getRemovedBacForSalesOrder(
                this.quotesHeaderData.salesOrderHeader
                  ?.accountsCoordinatorD365 ?? ""
              );
            } else {
              this.showBacUserInputField = false;
            }
          }
        },
      });
  }

  getBacForSaleOrderEdit(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            const filterBacObject = res.data.filter(
              x => x.personnelNumber === this.userPersonnelNumber
            );
            if (filterBacObject.length > 0) {
              this.bacUserDefaultSelectionId =
                filterBacObject[0].personnelNumber;
            } else {
              if (this.bacList.length > 0) {
                this.bacUserDefaultSelectionId =
                  this.bacList[0].personnelNumber;
                this.patchValueInBacField(this.bacUserDefaultSelectionId);
              } else {
                this.bacUserDefaultSelectionId = "";
              }
            }
          }
        },
      });
  }

  patchValueInBacField(personnelNumber: string) {
    this.quoteForm.patchValue({
      orderHeader: {
        accountsCoordinator: personnelNumber,
      },
    });
  }

  patchValueInBrandingConsultant(data: string) {
    this.quoteForm.patchValue({
      orderHeader: {
        brandingConsultant: data,
      },
    });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
          this.onShippingMethodChange({
            value: this.shippingMethodD365,
          } as SelectChangeEvent);
        },
      });
  }

  onShippingMethodChange(event: SelectChangeEvent) {
    const target = event.value;
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == target
    );

    if (index > -1) {
      this.patchValueInShippingMethod(
        this.shippingProductsList[index].modeDescriptionD365
      );
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        this.patchValueInAccount(selectedShippingMethod.jniFreightAcctNumD365);
      } else {
        this.patchValueInAccount("");
      }
    } else {
      this.patchValueInShippingMethod("");
    }
  }

  patchValueInShippingMethod(descriptionName: string) {
    this.quoteForm.patchValue({
      orderDetails: {
        shippingMethodName: descriptionName,
      },
    });
  }
  onClearShippingMethodSelection() {
    this.patchValueInAccount("");
  }

  patchValueInAccount(name: string) {
    this.quoteForm.patchValue({
      orderDetails: {
        account: name,
      },
    });
  }

  getMehtodPaymentListData() {
    const params = "?";
    this._saleOrderService
      .getMethodPaymentList(params)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerPaymentMethodList = res.data;
        },
      });
  }

  getCreditCard(event: SelectChangeEvent) {
    if (event.value === "CC") {
      this.applyCreditCardStatus = false;
    } else {
      this.applyCreditCardStatus = true;
    }
  }

  onShipDateSelection(event: Date) {
    //const shipDate = event;
    const shipDate = new Date(event);
    this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";

    if (this.shipDate) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.quoteForm.patchValue({
      orderHeader: {
        shipDate: this.shipDate,
      },
    });
  }

  onInHandDateSelection(event: Date) {
    //const inHandDate = event;
    const inHandDate = new Date(event);
    this.inHandDate = this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.quoteForm.patchValue({
      orderHeader: {
        inHandsDate: this.inHandDate,
      },
    });
  }

  calculateSumOfSellTotal() {
    if (this.salesOrderLine.length > 0) {
      const sumOfSellTotal = this.salesOrderLine.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellD365
              ? parseFloat(next.salesOrderLine?.sellD365.toString())
              : 0)
          );
        },
        0
      );
      this.sumOfSellTotal = sumOfSellTotal;
    }
  }

  calculateEstimatedTax(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    let estimatedTax = target.value.replace(/[^a-zA-Z0-9.]/g, "");
    estimatedTax = estimatedTax.substring(0, 10);
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(estimatedTax) ? "valid" : "invalid";
    if (revenue === "valid" && estimatedTax !== "") {
      this.estimatedTax = parseFloat(estimatedTax);
      if (estimatedTax === "" || estimatedTax === "0") {
        this.orderTotal = this.orderTotal - this.oldEstimatedTax;
      } else {
        this.orderTotal =
          parseFloat(estimatedTax) +
          parseFloat(this.subTotal) +
          this.estimatedFreight;
      }
      this.patchValueInEstimatedTax(estimatedTax);
      this.oldEstimatedTax = parseFloat(estimatedTax);
      this.quoteForm.patchValue({
        estimatedOrderTotals: {
          orderTotal: this.orderTotal,
        },
      });
    } else {
      target.value = "";
      this.clearEstimatedForm();
    }
  }

  calculateEstimatedFreight(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    let estimatedFreight = target.value.replace(/[^a-zA-Z0-9.]/g, "");
    estimatedFreight = estimatedFreight.substring(0, 10);
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(estimatedFreight) ? "valid" : "invalid";
    if (revenue === "valid" && estimatedFreight !== "") {
      this.estimatedFreight = parseFloat(estimatedFreight);
      if (estimatedFreight === "" || estimatedFreight === "0") {
        this.orderTotal = this.orderTotal - this.oldEstimatedFreight;
      } else {
        this.orderTotal =
          parseFloat(estimatedFreight) +
          parseFloat(this.subTotal) +
          this.estimatedTax;
      }
      this.patchValueInEstimatedFreight(estimatedFreight);
      this.oldEstimatedFreight = parseFloat(estimatedFreight);
      this.quoteForm.patchValue({
        estimatedOrderTotals: {
          orderTotal: this.orderTotal,
        },
      });
    } else {
      target.value = "";
      this.clearEstimatedForm();
    }
  }

  clearEstimatedForm() {
    this.estimatedTax = 0;
    this.estimatedFreight = 0;
    this.orderTotal = parseFloat(this.subTotal);
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        orderTotal: this.subTotal,
        estimatedTax: 0,
        estimatedFreight: 0,
      },
    });
  }

  patchValueInEstimatedTax(tax: string) {
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        estimatedTax: parseFloat(tax),
      },
    });
  }

  patchValueInEstimatedFreight(freight: string) {
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        estimatedFreight: parseFloat(freight),
      },
    });
  }

  calculateOrderTotal() {
    const total =
      parseFloat(this.subTotal) + this.estimatedTax + this.estimatedFreight;
    this.orderTotal = total;
  }

  calculateRecommendedTax() {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .getRecommendedTax(this.quoteId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (typeof res.data == "number") {
            this.patchValueInRecommendedTaxCalculate(res.data);
            // this.patchValueInEstimatedFreightCalculate(0);
            // this.patchValueInEstimatedTaxCalculate(0);
            // this.clearEstimatedForm();
            this._loaderService.setLoaderState(false);
            this._toastr.success(
              "Success",
              res.message || "Tax Calculated Successfully"
            );
            return;
          }

          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error While Calculating Tax"
          );
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error While Calculating Tax"
          );
        },
      });
  }

  patchValueInEstimatedTaxCalculate(estimatedTax: number) {
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        estimatedTax: estimatedTax,
      },
    });
    this.estimatedTax = estimatedTax;
    this.calculateOrderTotal();
  }

  patchValueInOrderTotal(orderTotal: number) {
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        orderTotal: orderTotal,
      },
    });
  }

  calculateSumOfSellTotalBeforeEdit(
    saleorderline: QuotesLineAddressDto[] | null
  ) {
    if (saleorderline && saleorderline.length > 0) {
      const sumOfSellTotal = saleorderline.reduce(
        (prev: number, next: QuotesLineAddressDto) => {
          return (
            prev +
            (next.salesOrderLine?.sellTotalD365
              ? parseFloat(next.salesOrderLine.sellTotalD365.toString())
              : 0)
          );
        },
        0
      );
      this.orderTotal = sumOfSellTotal;
      this.patchValueInOrderTotal(this.orderTotal);
    }
  }

  onBrandingConsultantSelection(drop: Popover, event: MouseEvent) {
    this.showSmallLoader = true;
    drop.show(event);
  }

  onProjectIdSelection(event: GetBCForSalesOrderDto, dropdown: Popover) {
    this.brandingConsultantObject = event;
    this.patchProjectIdInBCField(event);
    this.bcProjectId = event.personnelNumber;
    this.getBacForSaleOrderEdit(event.personnelNumber);
    dropdown.hide();
  }

  patchProjectIdInBCField(event: GetBCForSalesOrderDto) {
    this.quoteForm.patchValue({
      orderHeader: {
        brandingConsultant: event.projectName,
      },
    });
  }

  getOneTimeAddress() {
    const deliveryAddress = this.quoteForm.get([
      "shipTo",
      "addressSelectionName",
    ])?.value as string;

    if (deliveryAddress?.toLowerCase().includes("one")) {
      this.showAddress = false;
      return true;
    } else {
      this.quoteForm.get(["shipTo", "addressD365"])?.disable();
      this.showAddress = true;
      return false;
    }
  }

  setStateOfExpandAll() {
    localStorage.setItem("quote-collapse", "true");
  }

  setStateOfCollapseAll() {
    localStorage.setItem("quote-collapse", "false");
  }

  getStateOfCollapseAll() {
    const status = localStorage.getItem("quote-collapse");
    if (status) {
      if (status === "true") {
        this.collapseStatus = true;
        this.expandStatus = false;
        this.collapseHeading = "Expand all";
      } else {
        this.collapseStatus = false;
        this.expandStatus = true;
        this.collapseHeading = "Collapse all";
      }
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userObject = res.data;
          this.userPersonnelNumber = res.data.personnelNumber;
          this.netCommissionVisibleForBC(res?.data);
          // if (
          //   this.customerBillToObject?.clientType?.toLowerCase() === 'prospect'
          // ) {
          //   this.quoteForm.patchValue({
          //     orderHeader: {
          //       brandingConsultant: this.userObject.projectId
          //     }
          //   });

          //   const bac = this.quoteForm.get([
          //     'orderHeader',
          //     'accountsCoordinator'
          //   ])?.value;
          //   this.getBACNewList(this.userObject.id, bac);
          // }
        }
      },
    });
  }

  netCommissionVisibleForBC(data: GetUserDto) {
    if (
      data?.userRoleId === UserRole.Admin ||
      data?.personnelNumber === this.bcPersonnelNumber
    ) {
      this.netCommissionStatus = true;
    } else {
      this.netCommissionStatus = false;
    }
  }

  patchValueInEstimatedFreightCalculate(estimatedFreight: number) {
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        estimatedFreight: estimatedFreight,
      },
    });
    this.estimatedFreight = estimatedFreight;
    this.calculateOrderTotal();
  }

  patchValueInRecommendedTaxCalculate(recommendedTax: number) {
    this.quoteForm.patchValue({
      estimatedOrderTotals: {
        recommendedTax: recommendedTax,
      },
    });
    this.recommendedTax = recommendedTax;
  }

  saleOrderRedirect(url: string) {
    this.quoteId = url;
    const urls = "/proposal/quote-summary/" + url;
    this._router.navigate([urls]);
    this.ngOnInit();
  }

  copyCurrentHeader() {
    this.confirmationService.confirm({
      message: "Are you sure you want to copy this Proposal?",
      accept: () => {
        this.copyHeaderAgainstId();
      },
    });
  }

  copyHeaderAgainstId() {
    const linesArray: QuotesLinePortalKeyDto[] = [];
    this._loaderService.setLoaderState(true);

    this.salesOrderLine?.forEach((x: QuotesLineAddressDto) => {
      const line: QuotesLinePortalKeyDto = {
        ...(x.salesOrderLine! as QuotesLine),
        oldPortalKey: x?.salesOrderLine?.portalKeyD365 ?? null,
        portalKeyD365: uuidv4(),
        lineCopiedFrom: EnumCopiedFrom.IsFromQuote,
      };
      linesArray.push(line);
    });

    const copyLinesDto: CopyLinesQuotesDto = {
      quotesId: this.quoteId ?? "",
      quotesLinePortalKeyDtos: linesArray,
    };

    const copyLineArray: CopyQuotesRequestDto = {
      copyLinesDto: copyLinesDto,
      quotesNumber: this.quoteId ?? "",
      copiedFrom: EnumCopiedFrom.IsFromQuote,
    };

    this._createHeaderQuoteService
      .addHeaderData(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Success", res.message);
            this.saleOrderRedirect(
              res?.data?.orderHeader?.salesOrderIdD365 ?? ""
            );
          } else {
            this._toastr.error("Error", res.message || "Error adding header");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding header");
        },
      });
  }

  addAndRemoveButtons = true;
  displayEmailInvoiceModal = false;

  editInvoiceEmail() {
    if (this.salesOrderStatusD365.toLowerCase() !== "invoiced") {
      this.updateButtonValidation = false;
      this.quoteForm.get(["estimatedOrderTotals", "invoiceEmail"])?.enable();
      this.enableInvoiceEmail();
      this.addAndRemoveButtons = false;
      this.displayEmailInvoiceModal = true;
    } else {
      this.quoteForm.get(["estimatedOrderTotals", "invoiceEmail"])?.disable();
      this.disabledInvoiceEmail();
      this.addAndRemoveButtons = true;
      this.displayEmailInvoiceModal = false;
    }
  }

  private enableInvoiceEmail() {
    (this.quoteForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("name") as FormControl).enable();
        (group.get("purpose") as FormControl).enable();
        (group.get("email") as FormControl).enable();
        (group.get("confirmation") as FormControl).enable();
        (group.get("invoice") as FormControl).enable();
      }
    );
  }

  private disabledInvoiceEmail() {
    (this.quoteForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("name") as FormControl).disable();
        (group.get("purpose") as FormControl).disable();
        (group.get("email") as FormControl).disable();
        (group.get("confirmation") as FormControl).disable();
        (group.get("invoice") as FormControl).disable();
      }
    );
  }

  addNewLine(event: boolean) {
    if (event) {
      const invoicedEmail: InvoicedEmailSummaryDto = {
        electronicAddressIdD365: uuidv4(),
        exist: false,
        invoice: false,
        save: false,
        confirmation: false,
        email: "",
        name: "",
        purpose: "",
        id: 0,
        salesOrderIdD365: "",
        invoiceEmailRecIdD365: 0,
      };
      const control = this.quoteForm.get("invoicedEmail") as FormArray;
      control.insert(0, this.createInvoiceEmail(invoicedEmail));
      this.disableExisitInvoiceEmail();
    }
  }

  removeEmail(formgroup: FormGroup[]) {
    formgroup.forEach(x => {
      const value = x.get("electronicAddressIdD365")?.value;
      for (
        let i = 0;
        i < (this.quoteForm.get("invoicedEmail") as FormArray).length;
        i++
      ) {
        if (
          (this.quoteForm.get("invoicedEmail") as FormArray)
            .at(i)
            .get("electronicAddressIdD365")?.value == value
        ) {
          (this.quoteForm.get("invoicedEmail") as FormArray).removeAt(i--);
        }
      }
    });
  }

  createInvoiceEmail(invoicedEmail: InvoicedEmailSummaryDto) {
    return this._fb.group({
      electronicAddressIdD365:
        invoicedEmail.electronicAddressIdD365 || uuidv4(),
      name: invoicedEmail.name || "",
      purpose: invoicedEmail.purpose || "",
      email: invoicedEmail.email || "",
      confirmation: invoicedEmail.confirmation,
      exist: invoicedEmail.exist,
      invoice: invoicedEmail.invoice,
      save: invoicedEmail.save,
      id: invoicedEmail.id,
      salesOrderIdD365: invoicedEmail.salesOrderIdD365,
      invoiceEmailRecIdD365: invoicedEmail.invoiceEmailRecIdD365,
    } as InvoicedEmailSummaryDto);
  }

  private disableExisitInvoiceEmail() {
    (this.quoteForm.get("invoicedEmail") as FormArray).controls.forEach(
      group => {
        (group.get("exist") as FormControl).disable();
      }
    );
  }

  closeInvoiceEmailModel() {
    this.displayEmailInvoiceModal = false;
    this.quoteForm.get(["estimatedOrderTotals", "invoiceEmail"])?.disable();
    this.getQuotesEmails();
  }

  saveInvoiceEmailModel(invoicedEmail: QuotesInvoiceEmail[]) {
    if (!this.isEmailInvoiced(invoicedEmail)) {
      this._toastr.error("Error", "Atleast one email should be invoiced");
      return;
    }
    // if (this.EmailDuplicate(invoicedEmail)) {
    //   return;
    // }
    // if (this.invoiceEmailDuplicate(invoicedEmail)) {
    //   return;
    // }
    if (invoicedEmail.length > 0) {
      for (const item of invoicedEmail) {
        if (!item.email) {
          this._toastr.error("Error", "Email is required");
          return;
        }
      }
    }
    this.displayEmailInvoiceModal = false;
    this.quoteForm.get(["estimatedOrderTotals", "invoiceEmail"])?.disable();
    if (this.invoiceEmail?.length > 0) {
      this.invoiceEmail?.forEach((x: QuotesInvoiceEmail, index: number) => {
        if (x.invoiceEmailRecIdD365 === 0) {
          this.invoiceEmail[index].salesOrderIdD365 = this.quoteId;
        }
      });
    }

    const emailMap = new Map<string, InvoiceEmail>();
    for (const email of invoicedEmail) {
      if (email?.email && email.invoice) {
        emailMap.set(email.email, email);
      }
    }

    const invoiceEmail = Array.from(emailMap.values());

    if (!this.isEmailValid(invoiceEmail)) {
      this._toastr.error("Error", "Invalid email format");
      return;
    }

    this._loaderService.setLoaderState(true);
    invoiceEmail.forEach((x: InvoiceEmail) => {
      if (!x.salesOrderIdD365) {
        x.salesOrderIdD365 = this.quoteId;
      }
    });
    if (this.quoteId) {
      // const invoiceEmailObject = {
      //   saleOrderId: this.quoteId,
      //   invoiceEmail: invoiceEmail
      // };

      this._createHeaderQuoteService
        .updateInvoiceEmailSaleOrderHeaderData(invoiceEmail)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "Invoice Email Updated Successfully"
              );
              this.getQuotesEmails();
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error Updating Invoice Email"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error Updating Invoice Email"
            );
          },
        });
    }
  }

  removeInvoiceEmailModel(invoicedEmail: InvoiceEmail[]) {
    const arrayobject: number[] = [];
    invoicedEmail?.forEach(x => {
      if (x.invoiceEmailRecIdD365 != 0) {
        arrayobject.push(x.id);
      } else {
        const index = this.invoiceEmails.findIndex(y => y.id == x.id);
        if (index >= 0) {
          this.invoiceEmails.splice(index, 1);
        }
      }
    });

    if (arrayobject.length) {
      this._loaderService.setLoaderState(true);
      this._createHeaderQuoteService
        .deleteInvoiceEmailSaleOrderHeaderData(arrayobject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this._toastr.success(
                "Success",
                res.message || "Invoice email delete successfully"
              );
              this.getQuotesEmails();
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error deleting invoice email"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error deleting invoice email"
            );
          },
        });
    }
  }

  isEmailInvoiced(invoicedEmail: InvoiceEmail[]): boolean {
    for (const item of invoicedEmail) {
      if (item.invoice) {
        return true;
      }
    }
    return false;
  }

  isEmailValid(invoicedEmail: InvoiceEmail[]): boolean {
    let isEmail = true;
    for (const item of invoicedEmail) {
      const email: string = item.email;
      const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
      if (!RegExp(regex).exec(email)) {
        isEmail = false;
      }
    }
    if (isEmail) {
      return true;
    }
    return false;
  }

  isEmailDuplicate(): boolean {
    const control = this.quoteForm.get("invoicedEmail") as FormArray;
    const emailSet = new Set();
    for (let i = 0; i < control.length; i++) {
      emailSet.add((control.at(i) as FormGroup).get("email")?.value);
    }
    return control.length != emailSet.size;
  }

  // EmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
  //   for (let i = 0; i < invoicedEmail.length; i++) {
  //     const email = invoicedEmail[i].email;
  //     for (let j = i + 1; j < invoicedEmail.length; j++) {
  //       if (email === invoicedEmail[j].email) {
  //         this._toastr.error(
  //           'Error',
  //           `Email address "${email}". The record already exists.`
  //         );
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  // invoiceEmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
  //   const email = invoicedEmail[invoicedEmail.length - 1]?.email;
  //   const recid =
  //     invoicedEmail[invoicedEmail.length - 1]?.invoiceEmailRecIdD365;
  //   if (!recid) {
  //     for (let j = 0; j < this.invoiceEmails.length; j++) {
  //       if (email === this.invoiceEmails[j].email) {
  //         this._toastr.error(
  //           'Error',
  //           `Email address "${email}". The record already exists.`
  //         );
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  onClientRedirect() {
    if (this.editHeaderStatus === false) {
      this.customerId = this.quoteForm.get([
        "orderHeader",
        "customerId",
      ])?.value;
      this.clientDisplayModal = true;
      //this.renderer.addClass(document.body, 'height-max');
    }
  }

  openSideBarForOrderNotes() {
    this.displaySidebar = true;
    this.quotesidebar?.clearOrderNoteForm();
  }

  updateSideBarForOrderNotes() {
    this.quotenotes.updateSingleLine();
  }

  deleteSideBarForOrderNotes() {
    this.quotenotes.deleteSaleOrderNotes();
  }

  getSalesOrderNotes() {
    this.quotenotes.getQuoteNotes(this.quoteId);
  }

  closeSideBarForOrderNotes() {
    this.displaySidebar = false;
  }

  updateLineOnSideBar(selectedOrderNotesGridListing: SalesOrderNotes[]) {
    if (selectedOrderNotesGridListing?.length > 0) {
      this.displaySidebar = true;
      this.quotesidebar?.patchValueInOrderNote(
        selectedOrderNotesGridListing[0]
      );
    }
  }

  onNotesToggle() {
    if (this.expandNotesStatus) {
      this.collapseNotesStatus = true;
      this.expandNotesStatus = false;
      this.setNotesStateOfExpandAll();
      this.collapseNotesHeading = "Expand all";
    } else {
      this.collapseNotesStatus = false;
      this.expandNotesStatus = true;
      this.setNotesStateOfCollapseAll();
      this.collapseNotesHeading = "Collapse all";
    }
  }

  setNotesStateOfExpandAll() {
    localStorage.setItem("quote-Notes-collapse", "true");
  }

  setNotesStateOfCollapseAll() {
    localStorage.setItem("quote-Notes-collapse", "false");
  }

  getNotesStateOfCollapseAll() {
    const status = localStorage.getItem("quote-Notes-collapse");
    if (status) {
      if (status === "true") {
        this.collapseNotesStatus = true;
        this.expandNotesStatus = false;
        this.collapseNotesHeading = "Expand all";
      } else {
        this.collapseNotesStatus = false;
        this.expandNotesStatus = true;
        this.collapseNotesHeading = "Collapse all";
      }
    }
  }

  closeModal() {
    this.clientDisplayModal = false;
    //this.renderer.removeClass(document.body, 'height-max');
  }

  closeModalOnRedirection(event: string) {
    if (event) {
      this.saleOrderRedirect(event);
    }
    this.clientDisplayModal = false;
  }

  addScollHiddenClass() {
    if (this.quoteModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  onProposalAcceptedDateSelection(event: Date) {
    const acceptedDate = new Date(event);
    this.acceptedDate =
      this.datepipe.transform(acceptedDate, "MM/dd/yyyy") ?? "";
    this.quoteForm.patchValue({
      quoteStatus: {
        quoteAccepted: this.acceptedDate,
        quotesDateStatus: "Accepted",
        reason: "",
      },
    });
    this.reasonStatus = false;
    //this.acceptedDate = new Date().toString();
    this.acceptedProposal();
  }

  onProposalRejectedDateSelection(event: Date) {
    this.reasonStatus = true;
    const rejectedDate = new Date(event);
    this.rejectedDate =
      this.datepipe.transform(rejectedDate, "MM/dd/yyyy") ?? "";
    this.quoteForm.patchValue({
      quoteStatus: {
        quoteRejected: this.rejectedDate,
        quotesDateStatus: "Rejected",
      },
    });
    //this.quotesidebar.patchValueInNotes(this.rejectedDate, '');
  }

  onReasonSelection() {
    this.displaySidebar = true;
    this.rejectionReason = true;
    this.type = "System";
  }

  onQuoteNotesSave(saleOrderFormObject: QuotesNotes) {
    this._quoteNotesSidebarService
      .AddQuoteNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this.getSalesOrderNotes();
          if (this.proposalStatus) {
            this._router.navigate([
              "/orders/order-summary/" + this.salesOrderId,
            ]);
          }
        },
      });
  }

  onOrderNotesSave(saleOrderFormObject: QuotesNotes) {
    saleOrderFormObject.salesOrderId = this.salesOrderId;
    saleOrderFormObject.type = "Order note";

    this._quoteNotesSidebarService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  saleOrderFormObject!: QuotesNotes;

  getSideBarData(saleOrderFormObject: QuotesNotes) {
    this.saleOrderFormObject = saleOrderFormObject;
    this.onQuoteNotesSave(this.saleOrderFormObject);
  }

  onReasonChange(event: SelectChangeEvent) {
    this.quotesidebar.patchValueInNotes(
      this.rejectedDate,
      event.value as string
    );
    this.rejectedProposal();
  }

  hamburgerAccepted() {
    // const quoteFormObject = this.quoteForm.getRawValue();
    // quoteFormObject['quoteStatus'].quoteAccepted = new Date();
    const acceptedDate = new Date();
    this.acceptedDate =
      this.datepipe.transform(acceptedDate, "MM/dd/yyyy") ?? "";
    this.quoteForm.patchValue({
      quoteStatus: {
        quoteAccepted: acceptedDate,
      },
    });

    this.acceptedProposal();
  }

  hamburgerRejected() {
    const rejectedDate = new Date();
    this.rejectedDate =
      this.datepipe.transform(rejectedDate, "MM/dd/yyyy") ?? "";
    this.quoteForm.patchValue({
      quoteStatus: {
        quoteRejected: rejectedDate,
      },
    });
    this.reasonStatus = true;
    //this.rejectedProposal();
  }

  acceptedProposal() {
    this._loaderService.setLoaderState(true);
    const quoteFormObject = this.quoteForm.getRawValue();
    if (!quoteFormObject.quoteStatus.quoteAccepted) {
      this._toastr.error(
        "Error",
        `please select proposal accepted date
      `
      );
      this._loaderService.setLoaderState(false);
      return;
    }
    const quoteStatus = quoteFormObject.quoteStatus as UpdateDateRequestDto;
    quoteStatus.quotesId = this.quoteId;
    quoteStatus.quotesDateStatus = "Accepted";

    this._createHeaderQuoteService
      .acceptedRejectedAndCancelDate(quoteStatus)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this.quoteForm.patchValue({
            quoteStatus: {
              quoteAccepted: this.acceptedDate,
              quotesDateStatus: "Accepted",
              reason: "",
            },
          });
          this.salesOrderStatusD365 = "Accepted";
          this.orderNotes();
          this._toastr.success("Success", `Proposal accepted successfully`);
        },
        error: () => {
          this._toastr.error("Error", `Error accepting proposal`);
          this._loaderService.setLoaderState(false);
        },
      });
  }

  rejectedProposal() {
    this._loaderService.setLoaderState(true);
    const quoteFormObject = this.quoteForm.getRawValue();
    if (!quoteFormObject.quoteStatus.quoteRejected) {
      this._toastr.error(
        "Error",
        `please select proposal rejected date
      `
      );
      this._loaderService.setLoaderState(false);
      return;
    }
    if (!quoteFormObject.quoteStatus.reason) {
      quoteFormObject.quoteStatus.reason = "";
      this._toastr.error(
        "Error",
        `please select rejected reason
      `
      );
      this._loaderService.setLoaderState(false);
      return;
    }
    const quoteStatus = quoteFormObject.quoteStatus as UpdateDateRequestDto;
    quoteStatus.quotesId = this.quoteId;
    quoteStatus.quotesDateStatus = "Rejected";

    this._createHeaderQuoteService
      .acceptedRejectedAndCancelDate(quoteStatus)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this.quoteForm.patchValue({
            quoteStatus: {
              quoteRejected: this.rejectedDate,
              quotesDateStatus: "Rejected",
            },
          });
          this.salesOrderStatusD365 = "Rejected";
          this.orderNotes();
          this._toastr.success("Success", `Proposal rejected successfully`);
        },
        error: () => {
          this._toastr.error("Error", `Error rejecting proposal`);
          this._loaderService.setLoaderState(false);
        },
      });
  }

  cancelProposal() {
    this._loaderService.setLoaderState(true);
    this.quoteForm.patchValue({
      quoteStatus: {
        quotesDateStatus: "Cancel",
      },
    });
    this.salesOrderStatusD365 = "Cancel";
    const quoteFormObject = this.quoteForm.getRawValue();
    const quoteStatus = quoteFormObject.quoteStatus;
    quoteStatus.quotesId = this.quoteId;

    this._createHeaderQuoteService
      .acceptedRejectedAndCancelDate(quoteStatus)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this.cancelOrderNotes();
          this._toastr.success("Success", `Proposal cancel successfully`);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", `Error canceling proposal`);
        },
      });
  }

  cancelOrderNotes() {
    const reason = this.quoteForm.get(["quoteStatus", "reason"])?.value;
    const currentDate = new Date().toDateString();
    const notesObject = {
      salesOrderId: this.quoteId,
      portalKey: uuidv4(),
      type: "Proposal",
      description: "Cancelled",
      note: currentDate + " " + reason,
    } as QuotesNotes;
    this.onQuoteNotesSave(notesObject);
  }

  async convertedOrderNotes() {
    const currentDate = new Date().toDateString();
    const ordernotesObject = {
      salesOrderId: this.salesOrderId,
      portalKey: uuidv4(),
      type: "Order note",
      description: "Converted",
      note: currentDate + " " + this.salesOrderId,
    } as QuotesNotes;

    await lastValueFrom(
      this._quoteNotesSidebarService
        .AddSalesOrderNotes(ordernotesObject)
        .pipe(untilDestroyed(this))
    );

    //this.onOrderNotesSave(notesObject);
    const notesObject = {
      salesOrderId: this.quoteId,
      portalKey: uuidv4(),
      type: "Proposal",
      description: "Converted",
      note: currentDate + " " + this.salesOrderId,
    } as QuotesNotes;
    this.onQuoteNotesSave(notesObject);
  }

  sendProposalEmail() {
    //this._router.navigate([`proposal/po-email/${this.quoteId}`]);
    this.proposalDisplayModal = true;
  }

  closeModalForProposalEmail() {
    this.proposalDisplayModal = false;
    this.getQuoteData(this.loaderStatus);
  }

  onContactList(contactdropdown: Popover, event: MouseEvent) {
    contactdropdown.show(event);
  }

  // applyBuyerLengthValidation(event: any) {
  //   if (event.target.value) {
  //     this.quoteForm.patchValue({
  //       orderHeader: {
  //         buyer: event.target.value.substring(0, 50)
  //       }
  //     });
  //   }
  // }

  // onCustomerSelection(name: string, contactdropdown: any) {
  //   contactdropdown.close();
  //   this.quoteForm.patchValue({
  //     orderHeader: {
  //       buyer: name
  //     }
  //   });
  // }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber: string) {
    this.showSmallLoader = true;
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.showSmallLoader = false;
          this.clientContacts = data;
          this.transformClientContactData();
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  transformClientContactData() {
    this.ClientAddresses = [];

    this.populateClientContactInformation(this.clientContacts);
  }

  populateClientContactInformation(
    clientContacts: ClientContact[] | undefined
  ) {
    if (
      clientContacts != null &&
      clientContacts != undefined &&
      clientContacts.length > 0
    ) {
      clientContacts.forEach(element => {
        if (element?.locatorD365) {
          const clientAddress: ClientAddressCustomize = {};
          clientAddress.purpose = element.purposeD365;
          clientAddress.isPrimary = element.isPrimaryD365;
          clientAddress.name = element.descriptionD365;
          clientAddress.cust = element.cust;
          clientAddress.title = element.title;
          clientAddress.electronicAddressIdD365 =
            element.electronicAddressIdD365;

          if (element.typeD365 == EnumContactType.Phone) {
            clientAddress.phone = element.locatorD365;
            clientAddress.phoneLink = "tel:'" + element.locatorD365 + "'";
          } else if (element.typeD365 == EnumContactType.Email) {
            clientAddress.email = element.locatorD365;
            clientAddress.emailLink = "mailto:'" + element.locatorD365 + "'";
          }
          if (clientAddress.name) {
            this.ClientAddresses.push(clientAddress);
          }
        }
      });
    }
  }

  addContactInformation() {
    const getBuyerValue = this.quoteForm.get(["orderHeader", "buyer"])
      ?.value as string;
    if (this.customerBillToObject?.clientAccount && getBuyerValue) {
      const getSplitValues = getBuyerValue.split(" ");
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = getSplitValues[0] ?? "";
      this.addClientContact.lastName = getSplitValues[1] ?? "";
      this.addClientContact.type = "Buyer";
    } else {
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = "";
      this.addClientContact.lastName = "";
      this.addClientContact.type = "Buyer";
    }
    this.displayAddContact = true;
  }

  isContactAdded(obj: boolean) {
    if (obj) {
      this.getAllContactsByAccountNumber(
        this.customerAccountNumber,
        this.partyNumber
      );
      this.getAllBuyers();
    }
  }

  populateContactAddedInfo(obj: string) {
    if (obj) {
      this.quoteForm.patchValue({
        orderHeader: {
          buyer: obj,
        },
      });
    }
  }

  onBuyerSearchOpenToggle(mydrop: Popover, event: KeyboardEvent) {
    mydrop.hide();
    const target = event.target as HTMLInputElement;
    if (target.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  getBuyer(event: Event, mydrop: Popover) {
    const eventTarget = event.target as HTMLInputElement;
    const keyboardEvent = event as KeyboardEvent;
    this.showSmallLoader = true;
    if (keyboardEvent.key.toLocaleLowerCase() === "tab") {
      const countryValue = eventTarget.value;
      const request = {
        clientAccountNumber:
          this.quoteForm.get(["orderHeader", "customerIdValid"])?.value ||
          this.quoteForm.get(["orderHeader", "customerId"])?.value ||
          "",
        buyer: countryValue,
      } as GetAllBuyersRequestDto;
      this._buyerService
        .getAllBuyers(request)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            if (this.buyerLists.length > 0) {
              this.onBuyerSelection(this.buyerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover
  ) {
    this.buyerName = event.buyer;
    this.getCustomerAccountBuyer(event.account);
    this.onCustomerSelectionBuyer(event.buyer);
    buyerProspetToggle.hide();
  }

  onCustomerSelectionBuyer(name: string) {
    this.quoteForm.patchValue({
      orderHeader: {
        buyer: name,
      },
    });
  }

  addContactInformationBuyer() {
    const getBuyerValue = this.quoteForm.get(["orderHeader", "buyer"])
      ?.value as string;
    if (this.customerBillToObject?.clientAccount && getBuyerValue) {
      const getSplitValues = getBuyerValue.split(" ");
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = getSplitValues[0] ?? "";
      this.addClientContact.lastName = getSplitValues[1] ?? "";
      this.addClientContact.type = "Buyer";
    } else {
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = "";
      this.addClientContact.lastName = "";
      this.addClientContact.type = "Buyer";
    }
    this.displayAddContact = true;
  }

  searchBuyerName() {
    this.buyerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.smallLoaderEvent.emit(true);
          }

          const request = {
            clientAccountNumber:
              this.quoteForm.get(["orderHeader", "customerIdValid"])?.value ||
              this.quoteForm.get(["orderHeader", "customerId"])?.value ||
              "",
            buyer: searchitem,
          } as GetAllBuyersRequestDto;

          this.buyerLists = [];
          if (searchitem) {
            return this._buyerService.getAllBuyers(request);
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.buyerLists = res.data;
          }
          this.smallLoaderEvent.emit(false);
        },
        error: () => {
          this.smallLoaderEvent.emit(false);
        },
      });
  }

  getAllBuyers() {
    const request = {
      clientAccountNumber:
        this.quoteForm.get(["orderHeader", "customerIdValid"])?.value ||
        this.quoteForm.get(["orderHeader", "customerId"])?.value ||
        "",
      buyer: "",
    } as GetAllBuyersRequestDto;
    this._buyerService
      .getAllBuyers(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.buyerLists = res.data;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }
  ///////////buyer to client logic here /////////////////////

  onClientSelectionBuyer(event: ClientSearchList) {
    this.selectedAccountNumber = event.clientAccount;
    // this.clearInvoiceEmails();
    this.patchValueInCustomerAccount(this.selectedAccountNumber);
    this.customerBillToObject = event;
    this.customerBillToObjectEvent.emit(this.customerBillToObject);
    if (event.clientAccount != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
    this.patchValueInCustomerNameAndTelephoneField(event);
    this.patchValueInCustomerAccountField(event);
    this.patchValueInCustomerAddressFieldBuyer();
  }

  clearInvoiceEmails() {
    (this.quoteForm.get("invoicedEmails") as FormArray).clear();
  }

  patchValueInCustomerAccount(accountNumber: string) {
    this.quoteForm.patchValue({
      orderHeader: {
        customerId: accountNumber,
        customerIdValid: accountNumber,
      },
    });

    this.getBuyerEvent.emit();
  }

  patchValueInCustomerAddressFieldBuyer() {
    this._buyerService
      .getCustomerAddressByPartyNumber(
        this.customerBillToObject?.partyNumber,
        this.customerBillToObject?.clientAccount
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<Address[]>) => {
          this.showSmallLoader = false;
          const primaryAddress = res.data.filter(
            (x: Address) =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );

          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInCustomerFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          } else {
            this.patchValuesInCustomerFormAddressField("");
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  patchValueInCustomerAccountField(clientObj: ClientSearchList) {
    this.quoteForm.patchValue({
      orderHeader: {
        accountNumberD365: clientObj.clientAccount,
      },
    });
  }

  patchValueInCustomerNameAndTelephoneField(clientObj: ClientSearchList) {
    this.quoteForm.patchValue({
      customerAddress: {
        name: clientObj.organizationNameD365,
        telephone: clientObj.locator === null ? "" : clientObj.locator,
        billingLocationD365: clientObj.billingLocationD365,
        billingAttentionD365: clientObj.billingAttentionD365,
      },
    });
  }

  getCustomerAccountBuyer(accountNumber: string) {
    this.showSmallLoader = true;
    this._buyerService
      .getCustomerByNameAndAccountNumberFilter(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerLists = res.data;
          if (this.customerLists.length > 0) {
            this.onClientSelectionBuyer(this.customerLists[0]);
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  redirectToCopiedFrom() {
    if (this.quotesHeaderData?.salesOrderHeader?.copiedFromHeaderId) {
      if (
        this.quotesHeaderData?.salesOrderHeader?.copiedFrom ===
        EnumCopiedFrom.IsFromOrder
      ) {
        const url = `/orders/order-summary/${this.quotesHeaderData.salesOrderHeader.copiedFromHeaderId}`;
        window.open(url, "_blank");
      } else if (
        this.quotesHeaderData?.salesOrderHeader?.copiedFrom ===
        EnumCopiedFrom.IsFromQuote
      ) {
        const url = `/proposal/quote-summary/${this.quotesHeaderData.salesOrderHeader.copiedFromHeaderId}`;
        window.open(url, "_blank");
      }
    }
  }

  setCopiedFromInfo() {
    let copiedInfo = "";
    if (this.quotesHeaderData?.salesOrderHeader?.copiedFromHeaderId) {
      if (
        this.quotesHeaderData.salesOrderHeader.copiedFrom ===
        EnumCopiedFrom.IsFromOrder
      ) {
        copiedInfo =
          " Ord " + this.quotesHeaderData.salesOrderHeader.copiedFromHeaderId ||
          "";
      } else if (
        this.quotesHeaderData.salesOrderHeader.copiedFrom ===
        EnumCopiedFrom.IsFromQuote
      ) {
        copiedInfo =
          " Proposal " +
            this.quotesHeaderData.salesOrderHeader.copiedFromHeaderId || "";
      }
    }
    return copiedInfo;
  }

  onCloseModal() {
    this.closeModalEvent.emit();
  }

  populateMenuItem() {
    this.items = [
      {
        label: "Accepted Proposal",
        command: () => {
          this.hamburgerAccepted();
        },
      },
      {
        label: "Reject Proposal",
        command: () => {
          this.hamburgerRejected();
        },
      },
      {
        label: "Cancel Proposal",
        command: () => {
          this.cancelProposal();
        },
      },
      {
        label: "Convert",
        command: () => {
          this.onQuoteConvert();
        },
      },
    ];
  }

  patchValueInCurrency(value = "USD") {
    this.quoteForm.patchValue({
      orderDetails: {
        foreignCurrency: value,
      },
    });
  }

  getRemovedBacForSalesOrder(personnelNumber: string) {
    this._orderSummaryService
      .getEmployeeByPersonnelNumber(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.showBacUserInputField = true;

            this.removedBacUser =
              res.data.personnelNumber +
              " : " +
              res.data.firstName +
              " " +
              res.data.lastName;
          } else {
            this.showBacUserInputField = false;
          }
        },
      });
  }

  /**
   * Returns true when the currently selected shipping method is a
   * Nadel freight account (e.g. FedEx / UPS Nadel Account). In that case
   * the supplier account number must be auto-populated and non-editable.
   */
  get isNadelFreightAccount(): boolean {
    const shippingMethodCode = this.quoteForm?.get([
      "orderDetails",
      "shippingMethod",
    ])?.value;
    if (!shippingMethodCode || !this.shippingProductsList?.length) {
      return false;
    }
    const method = this.shippingProductsList.find(
      x => x.modeCodeD365 === shippingMethodCode
    );

    if (method?.useFreightAccountD365?.toLowerCase() !== "yes") {
      return false;
    }

    // Client requirement: only hide/lock the account number when the
    // shipping method is UPS or FedEx (Nadel freight accounts).
    const description = method?.modeDescriptionD365?.toLowerCase() ?? "";
    return description.includes("ups") || description.includes("fedex");
  }
}
